import Vue from 'vue';
import Vuetify, { VTextField, VCheckbox, VDataTable, VAutocomplete } from 'vuetify/lib';
import 'material-design-icons-iconfont/dist/material-design-icons.css'; // Ensure you are using css-loader
// import VTextField from 'vuetify/lib/components/VTextField/VTextField'
// import VCheckbox from 'vuetify/lib/components/VCheckbox/VCheckbox'
VTextField.options.props.dense.default = true;
VTextField.options.props.outlined.default = true;
VTextField.options.props.hideDetails.default = 'auto';
VAutocomplete.options.props.outlined.default = true;
VAutocomplete.options.props.dense.default = true;
VCheckbox.options.props.hideDetails.default = 'auto';
VDataTable.options.props.itemsPerPage.default = 9999;
VDataTable.options.props.dense.default = true;
VDataTable.options.props.hideDefaultFooter.default = true;
VDataTable.options.props.disableSort.default = true;
Vue.use(Vuetify);
export default new Vuetify({});
